const p = {
  small: "3px",
  default: "4px",
  elevation: "6px",
  block: "6px",
  global: "8px",
  input: "8px",
  page: "16px",
  table: "16px",
  bubble: "10px",
  overlay: "10px",
  circle: "100px"
};
export {
  p as radius
};
